<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: p_fy
 * @LastEditTime: 2019-08-26 18:40:36
 * @Description: 我的邀请列表，状态：普仓、罐区。
 -->
<template>
  <div class="content-container">
    <div class="demand-head">
      <div class="slider-list" @click="toggleState">
        <div :class="{ 'selected': !state}" class="item">普仓</div>
        <div :class="{ 'selected': state}" class="item">罐区</div>
      </div>
      <!-- 查询表单  -->
    </div>

    <!--存入表格数据-->
    <article class="operations" />

    <div v-loading="viewManager.loading" class="demand-data">
      <div class="demand-data-header">
        <ul>
          <!-- <li>
            <input v-model="allSelection" type="checkbox" @change="selection()">
          </li> -->
          <li>租单名称</li>
          <li>储存类型</li>
          <li v-if="!state">需求面积</li>
          <li v-if="state">罐区容积</li>
          <li>期望租金</li>
          <li>邀请看仓位置</li>
          <li>对方意向</li>
          <li>操作</li>
        </ul>
      </div>
      <div ref="data-body" class="demand-data-body">
        <template v-if="!viewManager.loading && data.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(demand, index) of data">
          <div :key="index" class="data-item">
            <ul>
              <!-- <li>
                <input v-model="demand.selection" type="checkbox" @change="change()">
              </li> -->
              <el-tooltip class="item" effect="dark" :content="`${demand.demandName}`" placement="top">
                <li>{{ demand.demandName }}</li>
              </el-tooltip>
              <el-tooltip v-if="!state" class="item" effect="dark" :content="`${demand.storageTypeLabel}`" placement="top">
                <li>{{ demand.storageTypeLabel }}</li>
              </el-tooltip>
              <el-tooltip v-if="state" class="item" effect="dark" :content="`${demand.tankTypeLabel}`" placement="top">
                <li>{{ demand.tankTypeLabel }}</li>
              </el-tooltip>
              <el-tooltip v-if="!state" class="item" effect="dark" :content="`${demand.demandArea}m²`" placement="top">
                <li>{{ demand.demandArea }}m²</li>
              </el-tooltip>
              <el-tooltip v-if="state" class="item" effect="dark" :content="`${demand.goodsCubage}m³`" placement="top">
                <li>{{ demand.goodsCubage }}m³</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${demand.expectPrice}${!state ? '元/m²/天' : '元/罐·天'}`" placement="top">
                <li>{{ demand.expectPrice }}{{ !state ? '元/m²/天' : '元/罐/天' }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${demand.storageLocationLabel}`" placement="top">
                <li>{{ demand.storageLocationLabel }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${demand.statusLabel}`" placement="top">
                <li>{{ demand.statusLabel }}</li>
              </el-tooltip>
              <li>
                <!-- <el-button type="text" style="color: #66b1ff !important;">成交</el-button> -->
                <!-- <el-divider direction="vertical" /> -->
                <el-button plain size="small" @click="demandInfo(demand)">
                  详情
                  <i :class="{'expand': !demand.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
              <!-- <el-button v-if="state" type="text" @click="popRecommendList(demand.id)">仓库推荐</el-button>
                <el-divider v-if="state" direction="vertical" />
                <el-button type="text" @click="edit(demand)">编辑</el-button>
                <el-divider direction="vertical" />
                <el-button type="text" @click="del(demand)">删除</el-button>
                <el-divider direction="vertical" />
                <el-button plain size="small" @click="demandInfo(demand)">
                  详情
                  <i :class="{'expand': !demand.hidden}" class="el-icon-d-arrow-right" />
                </el-button> -->
            </ul>
            <storeDemandInfo v-if="!demand.hidden && !state" :demand="demand" />
            <tankDemandInfo v-if="!demand.hidden && state" :demand="demand" />
          </div>
        </template>
      </div>
      <div class="demand-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
// 普仓需求详情
import storeDemandInfo from '../store-demand-list/components/storeDemandInfo'
// 罐区需求详情
import tankDemandInfo from '../tank-demand-list/components/tankDemandInfo'
import { findPageInvitation } from '@/api/personal/store/my-invitation/myInvitation'
import { tableClass } from '@/api/personal/store/store-demand-list/StoreDemandParam'

const table = tableClass.getTable() // 引用表格参数类

export default {
  name: 'MyInvitation',
  components: {
    storeDemandInfo,
    tankDemandInfo
  },
  data: function() {
    return {
      data: [],
      area: [],
      allSelection: false,
      // 表格数据
      pagination: table.Page,
      queryParams: {
      },
      state: false,
      viewManager: {
        loading: true
      }
    }
  },
  computed: {
    getPublishState() {
      return this.state ? 2 : 1
    }
  },
  watch: {
    state: function() {
      this.loadData()
    }
  },
  created: function() {
    (async() => {
      this.loadData()
    })()
  },
  methods: {
    // 列表切换
    toggleState(e) {
      if (e.target.className == 'item') {
        this.state = !this.state
      // this.loadData()
      }
    },
    // 子项选择
    change() {
      this.allSelection = this.data.every(i => i.selection)
    },
    // 全选
    selection() {
      this.data.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    // 监听分页
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    // 监听分页
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    // 初始化查询
    loadData() {
      this.viewManager.loading = true
      this.queryParams.warehousingType = this.getPublishState
      this.queryParams.publishStatus = '2'
      this.loadTableData()
    },
    // 详情展示
    demandInfo(demand) {
      if (demand.hidden) {
        this.data.map(res => {
          res.hidden = true
          return res
        })
      }
      demand.hidden = !demand.hidden
    },
    // 查询
    loadTableData() {
      const params = Object.assign(this.pagination, this.queryParams)
      findPageInvitation(params)
        .then(data => {
          this.data = data.result.rows.map(res => {
            res.hidden = true
            res.selection = false
            return res
          })
          this.pagination.total = data.result.total
        })
        .catch(error => {
          this.pagination.total = this.data.length
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

$main-color: #be2316;

.content-container {
  .demand-head {
    padding: 1rem;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;
        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .demand-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: "";
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .operations {
    margin: 16px 0px;
  }

  .demand-data {
    .demand-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 15%;
          }
          &:nth-child(2) {
            flex-basis: 15%;
          }
          &:nth-child(3) {
            flex-basis: 15%;
          }
          &:nth-child(4) {
            flex-basis: 15%;
          }
          &:nth-child(5) {
            flex-basis: 15%;
          }
          &:nth-child(6) {
            flex-basis: 15%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          // &:nth-child(7) {
          //   flex-basis: 15.8%;
          // }
        }
      }
    }

    .demand-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

    //       @keyframes slider-in {
    //   from {
    //     transform: translateX(100%);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(0);
    //     opacity: 1;
    //   }
    // }
    //  @keyframes slider-out {
    //   from {
    //     transform: translateX(0);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(-100%);
    //     opacity: 1;
    //   }
    // }
    // &.slider-in {
    //   visibility:visible !important;
    //   animation: slider-in 1s ease-in;
    // }
    // &.slider-out {
    //   visibility:visible !important;
    //   animation: slider-out 1s ease-out;
    // }
    // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(3) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(4) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(5) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(6) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            // &:nth-child(7) {
            //   flex-basis: 15.8%;
            // }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .demand-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .invitation-data {
    .invitation-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 15%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 15%;
          }
          &:nth-child(10) {
            flex-basis: 15%;
          }
        }
      }
    }
    .invitation-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 15%;
            }
            &:nth-child(2) {
              flex-basis: 10%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 15%;
            }
            &:nth-child(10) {
              flex-basis: 15%;
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .invitation-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .bid-data {
    .bid-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 15%;
          }
          &:nth-child(3) {
            flex-basis: 8%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 7%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
          &:nth-child(11) {
            flex-basis: 10%;
          }
        }
      }
    }
    .bid-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
            }
            &:nth-child(3) {
              flex-basis: 8%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 7%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
            &:nth-child(11) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .bid-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .recommend-data {
    .recommend-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
        }
      }
    }
    .recommend-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 10%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .recommend-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
      width: 100%;
    }
  }
}
</style>
